import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Image,
  Modal,
  Upload,
  Tooltip,
  message,
} from "antd";
import { FilePdfOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import FilePdf from "../../../assets/images/pdf.png";
import { useLocation, useNavigate } from "react-router";
import toastr from "toastr";
import { getRequest, postRequest } from "../../../api/http";
import caService from "../../../api/caService";
import "./TaskInfo.scss";
import { LoadingView } from "../../common";
import moment from "moment";

const { Dragger } = Upload;

function TaskInfo() {
  const [form] = Form.useForm();
  const [task, setTask] = useState({});
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [questionFiles, setQuestionFiles] = useState([]);
  const [answerFiles, setAnswerFiles] = useState([]);
  const [description, setDescription] = useState("");
  const [submissions, setSubmissions] = useState([]);
  const location = useLocation();
  const taskId = location.state.taskId;
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [links, setLinks] = useState([{ id: 0, url: "" }]);
  const fileExtensionToMimeType = {
    pdf: "application/pdf",
    jpeg: "image/jpeg",
    jpg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    csv: "text/csv",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // Add more file types as needed
  };

  const imageTypes = ["image/jpeg", "image/png", "image/gif"];
  const documentTypes = [
    "application/pdf",
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  const handleAddLink = () => {
    setLinks([...links, { id: links.length, url: "" }]);
  };

  const handleRemoveLink = (id) => {
    setLinks(links.filter((link) => link.id !== id));
  };

  const handleLinkChange = (id, value) => {
    console.log(value, "value");
    setLinks(
      links.map((link) => (link.id === id ? { ...link, url: value } : link)),
    );
  };

  const getTaskById = async () => {
    setLoading(true);
    try {
      const response = await getRequest(caService.getTaskById(taskId));
      setTask(response);
      if (response.fileUrls) {
        setQuestionFiles(
          response.fileUrls.map((url, index) => {
            const extension = url.split(".").pop().toLowerCase();
            const type =
              fileExtensionToMimeType[extension] || "application/octet-stream";
            return {
              uid: index,
              name: `File ${index + 1}`,
              status: "done",
              url: url,
              type: type,
            };
          }),
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching tasks:", error);
      toastr.error(error.message);
    }
  };

  useEffect(() => {
    getTaskById();
    getSubmissions(taskId);
  }, []);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const getSubmissions = async (taskId) => {
    setLoading(true);
    try {
      const response = await getRequest(
        caService.getAllSubmissions(user.campusAmbassadorId, taskId),
      );
      setSubmissions(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toastr.error(error.message);
    }
  };
  const fetchTaskreport = async (taskAssignmentId) => {
    try {
      const response = await getRequest(
        caService.getTaskreport(taskAssignmentId),
      );
      window.open(response.downloadLink, "_blank");
    } catch (error) {
      toastr.error(error.message);
    }
  };
  const handleOk = async () => {
    const values = await form.validateFields();
    const filteredLinks = links.filter((link) => link.url.trim() !== "");
    console.log(filteredLinks, "filtered links");
    const payload = {
      description,
      referenceUrls: filteredLinks.map((link) => link.url),
    };
    console.log(payload, "payload");

    const formData = new FormData();
    formData.append(
      "data",
      new Blob([JSON.stringify(payload)], { type: "application/json" }),
    );

    answerFiles.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    try {
      await postRequest(caService.submitTask(user.id, taskId), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      getTaskById();
      getSubmissions(taskId);
      setIsModalVisible(false);
      toastr.success("Files submitted successfully!");
    } catch (error) {
      toastr.error(error.message);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const MAX_TOTAL_SIZE = 10 * 1024 * 1024; // 10MB

  const handleChange = (info) => {
    const filteredList = info.fileList.filter((file) => {
      const isValidType = imageTypes.includes(file.type);

      if (!isValidType) {
        message.error(`${file.name} is not a valid image format.`);
        return false;
      }

      return true;
    });

    // Calculate total size
    const totalSize = filteredList.reduce((acc, file) => {
      return acc + (file.size || 0);
    }, 0);

    console.log(totalSize, "total size");

    if (totalSize > MAX_TOTAL_SIZE) {
      message.error("Total image size must be less than 10MB.");
      return;
    }

    setAnswerFiles(filteredList);
  };

  const renderFilePreview = (file) => {
    if (imageTypes.includes(file.type)) {
      return (
        <a href={file.url} download target="_blank" rel="noopener noreferrer">
          <Image
            src={file.url}
            alt={file.name}
            style={{
              fontSize: "32px",
              color: "#ff4d4f",
              height: "50px",
              width: "70px",
            }}
          />
        </a>
      );
    } else if (documentTypes.includes(file.type)) {
      let iconSrc;
      switch (file.type) {
        case "application/pdf":
          iconSrc = FilePdf;
          break;
        case "text/csv":
          iconSrc = FilePdf;
          break;
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          iconSrc = FilePdf;
          break;
        default:
          iconSrc = null;
      }
      return (
        <a href={file.url} target="_blank" rel="noopener noreferrer">
          <Image
            src={iconSrc}
            style={{
              fontSize: "32px",
              color: "#ff4d4f",
              height: "50px",
              width: "70px",
            }}
            preview={false}
          />
        </a>
      );
    } else {
      return (
        <a href={file.url} target="_blank" rel="noopener noreferrer">
          <FilePdfOutlined />
        </a>
      );
    }
  };
  function formatDate(dateString) {
    const localTime = moment(dateString).local();
    return localTime.format("MMM D , YYYY");
  }
  if (loading) return <LoadingView />;
  return (
    <>
      <div className="header-events">
        <div className="heading">{task?.name || "Task"}</div>
        <div className="headingButton">
          <Button onClick={() => navigate(-1)} type="primary">
            Back
          </Button>
        </div>
      </div>
      {task.bannerImageUrl && (
        <div className="bannerImage">
          <Image
            src={task.bannerImageUrl}
            alt={task.name}
            className="bannerImageTag"
            preview={false}
          />
        </div>
      )}
      <div className="task-info-card">
        <div className="task-info-content">
          <div className="task-detail">
            <strong>Description:</strong>
            <p>{task?.description || "No description available"}</p>
          </div>
          <div className="task-detail">
            <strong>Reporting Details:</strong>
            <span>
              {task?.reportingDetails || "No reporting details available"}
            </span>
          </div>
          <div className="task-detail">
            <strong>Reward Details:</strong>
            <span>
              {task?.rewardName},{" "}
              {task?.rewardDescription || "No reporting details available"}
            </span>
          </div>
          <div className="task-detail">
            <strong>Resubmission Count Limit :</strong>
            <span>{task?.resubmissionCountLimit || "N/A"}</span>
          </div>
          {questionFiles?.length != 0 ? (
            <div className="task-detail">
              <strong>Resources:</strong>
              <div className="file-previews">
                {questionFiles?.map((file) => (
                  <div key={file.uid} className="file-preview">
                    {renderFilePreview(file)}
                  </div>
                ))}
              </div>
            </div>
          ) : null}
          {task?.taskReferenceUrls?.length > 0 && (
            <div className="task-detail">
              <strong>Reference urls:</strong>
              <div className="file-previews">
                {task?.taskReferenceUrls?.map((url, index) => (
                  <div key={index}>
                    {url ? (
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        {url}
                      </a>
                    ) : (
                      <span>N/A</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <Button
          type="primary"
          className="task-info-button"
          onClick={showModal}
          disabled={
            task?.taskStatus === null ||
            task?.reportStatus === "APPROVED" ||
            task?.reportStatus === "SUBMITTED" ||
            task?.taskStatus === "ASSIGNED" ||
            task?.limitExceeds
          }
        >
          Upload
        </Button>

        <Modal
          title="Upload Files"
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
        >
          <Form form={form} layout="vertical" onFinish={handleOk}>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                { required: true, message: "Please enter a description!" },
              ]}
            >
              <Input.TextArea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
                placeholder="Enter description"
              />
            </Form.Item>
            <Form.Item label="Add Links (if any)">
              {links.map((link, index) => (
                <div
                  key={link.id}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Input
                    placeholder="Enter link"
                    value={link.url}
                    onChange={(e) => handleLinkChange(link.id, e.target.value)}
                    style={{ width: "calc(100% - 40px)", margin: "10px" }}
                  />
                  <MinusCircleOutlined
                    onClick={() => handleRemoveLink(link.id)}
                    style={{ fontSize: "24px" }}
                  />
                </div>
              ))}
              <Button
                type="dashed"
                onClick={handleAddLink}
                block
                icon={<PlusOutlined />}
                style={{ marginTop: "20px" }}
              >
                Add Link
              </Button>
            </Form.Item>
            <Form.Item name="files" label="Upload Images">
              <Upload
                multiple={true}
                fileList={answerFiles}
                beforeUpload={() => false}
                onChange={handleChange}
                listType="picture-card"
                // showUploadList={{ showPreviewIcon: false }}
              >
                <div icon={<PlusOutlined />}>+ Upload</div>
              </Upload>
              <div style={{ marginTop: 8, color: "#8c8c8c" }}>
                <p>
                  <b>*Note:</b> Size of the Images should be less than 10MB.
                  Image format should be PNG/JPEG/JPG.
                </p>
              </div>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>

      {task?.taskStatus && (
        <>
          <div className="heading" style={{ margin: "20px" }}>
            Submission History
          </div>
          <div className="submission-table">
            <table className="responsive-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Date</th>
                  <th>Report status</th>
                  <th className="actions"></th>
                </tr>
              </thead>
              <tbody>
                {submissions.length > 0 ? (
                  submissions.map((submission, index) => (
                    <tr key={index}>
                      <td data-label="title">{submission.submissionData}</td>
                      <td data-label="date">
                        {formatDate(submission.submissionDate)}
                      </td>
                      {submission.reportStatus === "REJECTED" ? (
                        <td data-label="status">
                          {submission.reportStatus}
                          <Tooltip title={submission.rejectionReason}>
                            <InfoCircleOutlined
                              style={{
                                color: "#ed9f0b",
                                cursor: "pointer",
                                marginLeft: "5px",
                              }}
                            />
                          </Tooltip>
                        </td>
                      ) : (
                        <td data-label="status">{submission.reportStatus}</td>
                      )}
                      <td data-label="Actions" className="actions">
                        <div
                          onClick={(e) => {
                            fetchTaskreport(submission.taskAssignmentId);
                          }}
                          className="pdf-icon"
                        >
                          <FilePdfOutlined />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No submissions found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

export default TaskInfo;
